/**
 * Older Safari (iPad mini 2 stops at iOS 12) has no <dialog>. The dashboard's popups use showModal(), so on those
 * browsers load a small polyfill first. Modern browsers skip all of this and use their own dialogs.
 */
export async function installDialogShim(): Promise<void> {
  const probe = document.createElement('dialog') as HTMLDialogElement;
  if (typeof probe.showModal === 'function') return;

  const [{ default: polyfill }] = await Promise.all([import('dialog-polyfill'), import('dialog-polyfill/dist/dialog-polyfill.css')]);
  const register = (root: ParentNode) => root.querySelectorAll('dialog').forEach((d) => polyfill.registerDialog(d));
  register(document);
  // Popups are created as pages render; register each one as it appears.
  new MutationObserver((changes) => {
    for (const change of changes) {
      change.addedNodes.forEach((node) => {
        if (!(node instanceof Element)) return;
        if (node.tagName === 'DIALOG') polyfill.registerDialog(node as HTMLDialogElement);
        register(node);
      });
    }
  }).observe(document.body, { childList: true, subtree: true });
}
